// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"845":"cbd17ae7","882":"0d8c1618"}[chunkId] + ".chunk.js";
};